import { Box, Image, HStack, Stack } from '@chakra-ui/react';
import { Rating } from './Rating';

export function UserBanner({
  user_id,
  user_img,
  user_name,
  user_rating,
  user_total_ratings,
  style,
}) {
  return (
    <HStack
      fontSize="12px"
      // bg="gray.700"
      // borderRadius={'25px 0px 0px 25px'}
      p="1"
      pl="0"
      pr="3"
      pt="1.5"
      {...style}
    >
      <Image
        w={'20px'}
        h={'20px'}
        src={user_img}
        alt={user_name}
        borderRadius="20px"
      />
      {/* <Stack align="baseline" spacing="0"> */}
      <Box fontWeight="bold">{user_name}</Box>
      {/* <Rating
          color="gray.400"
          value={user_rating}
          total={user_total_ratings}
        />
      </Stack> */}
    </HStack>
  );
}
